"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _templateObject;
const HintText = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", " 0 0 0;\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  text-align: ", ";\n"])), (0, _constant.get)('space.4'), (0, _constant.get)('colors.functional.grey.600'), (0, _constant.get)('fontSizes.14'), (0, _constant.get)('lineHeights.20'), props => props.hintPosition === 'right' ? 'right' : 'left');
const Components = exports.Components = {
  HintText
};